import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap-modal';
import moment from 'moment/moment';
import SimpleFilter from './simple-filter'
import GroupFilter from './group-filter';

function FilterForm({filters, regionsAndLocations, onClose, onSubmit}) {
  const allColumns = {
    name: {title: 'Name', conditions: ['contains', 'does not contain', 'is empty', 'is not empty']},
    phone: {title: 'Phone', conditions: ['contains', 'does not contain', 'is empty', 'is not empty']},
    region: {title: 'Region', conditions: ['contains', 'does not contain', 'is empty', 'is not empty']},
    dates_joined: {title: 'Date Joined', conditions: ['is', 'is not', 'is before', 'is after']},
    times_played: {title: 'Times Played', conditions: ['=', '!=', '<', '>', '<=', '>=', 'is empty', 'is not empty']},
    dates_played: {title: 'Dates Played', conditions: ['is', 'is not', 'is before', 'is after', 'is empty', 'is not empty']},
    facility: {title: 'Facility Played', conditions: ['contains', 'does not contain', 'is empty', 'is not empty']},
    cancelled_games: {title: 'Cancelled Games', conditions: ['is', 'is not', 'is before', 'is after', 'is empty', 'is not empty']},
    gender: {title: 'Gender', conditions: ['is', 'is not', 'is empty', 'is not empty']},
    opted_out: {title: 'Opted out', conditions: ['is', 'is not']},
    banned: {title: 'Banned', conditions: ['is', 'is not']},
    devices_banned: {title: 'Devices Banned', conditions: ['is', 'is not']},
    captain: {title: 'Captain', conditions: ['is', 'is not']},
    free_games: {title: 'Free Player', conditions: ['is', 'is not']},
    email: {title: 'Email', conditions: ['contains', 'does not contain', 'is empty', 'is not empty']},
    date_of_birth: {title: 'Date Of Birth', conditions: ['is', 'is not', 'is before', 'is after']},
    hide_fake_players: {title: 'Hide Fake Players', conditions: ['is']},
    hide_facility_players: {title: 'Hide Facility Players', conditions: ['is']},
    info: {title: 'Note', conditions: ['contains', 'does not contain', 'is empty', 'is not empty']}
  }

  const [filtersList, setFiltersList] = useState(filters)

  const addCondition = (i) => {
    if (i[0] == -1) filtersList.push({type: 'and', group: false, column: 'name', condition: 'contains', value: ''})
    else recAddCondition(i, filtersList)
    setFiltersList([...filtersList])
  }

  const recAddCondition = (i, item) => {
    if (i.length == 1) item[i[0]].items.push(
      {type: 'and', group: false, column: 'name', condition: 'contains', value: ''})
    else recAddCondition(i.slice(1), item[i[0]].items)
  }

  const addConditionGroup = (i) => {
    if (i[0] == -1) filtersList.push(
      {type: 'and', group: true, items: [{column: 'name', condition: 'contains', value: ''}]})
    else recAddConditionGroup(i, filtersList)
    setFiltersList([...filtersList])
  }

  const recAddConditionGroup = (i, item) => {
    if (i.length == 1) item[i[0]].items.push({
      type: 'and', group: true, items: [{column: 'name', condition: 'contains', value: ''}]})
    else recAddConditionGroup(i.slice(1), item[i[0]].items)
  }

  const updateType = (value, i) => {
    recUpdateType(value, i, filtersList)
    setFiltersList([...filtersList])
  }

  const recUpdateType = (value, i, item) => {
    if (i.length == 1) item[i[0]].type = value
    else recUpdateType(value, i.slice(1), item[i[0]].items)
  }

  const updateColumn = (value, i) => {
    recUpdateColumn(value, i, filtersList)
    setFiltersList([...filtersList])
  }

  const recUpdateColumn = (value, i, item) => {
    if (i.length == 1) {
      item[i[0]].column = value

      switch (value) {
        case 'dates_joined':
        case 'dates_played':
        case 'cancelled_games':
        case 'date_of_birth':
          item[i[0]] = {...item[i[0]], condition: 'is before',
            conditionChild: 'today', value: moment()}
          break
        case 'region':
          item[i[0]] = {...item[i[0]], condition: 'contains', value: regionsAndLocations['region'][0].id}
          break
        case 'facility':
          item[i[0]] = {...item[i[0]], condition: 'contains', value: []}
          break
        case 'gender':
          item[i[0]] = {...item[i[0]], condition: 'is', value: 'male'}
          break
        case 'opted_out':
        case 'captain':
        case 'free_games':
        case 'banned':
        case 'devices_banned':
          item[i[0]].value = false
          break
        case 'hide_fake_players':
        case 'hide_facility_players':
          item[i[0]].value = true
          break
        case 'times_played':
          item[i[0]] = {...item[i[0]], condition: '>', conditionChild: 'is not empty',
            value: 0}
          break
        case 'name':
        case 'phone':
        case 'email':
        case 'info':
          item[i[0]].value = ''
        default:
          item[i[0]] = {...item[i[0]], condition: allColumns[value].conditions[0]}
      }
    }
    else recUpdateColumn(value, i.slice(1), item[i[0]].items)
  }

  const updateCondition = (value, i) => {
    recUpdateCondition(value, i, filtersList)
    setFiltersList([...filtersList])
  }

  const recUpdateCondition = (value, i, item) => {
    if (i.length == 1) item[i[0]].condition = value
    else recUpdateCondition(value, i.slice(1), item[i[0]].items)
  }

  const updateValue = (value, i) => {
    recUpdateValue(value, i, filtersList)
    setFiltersList([...filtersList])
  }

  const recUpdateValue = (value, i, item) => {
    if (i.length == 1) item[i[0]].value = value
    else recUpdateValue(value, i.slice(1), item[i[0]].items)
  }

  const updateDateConditionChild = (value, i) => {
    recUpdateDateConditionChild(value, i, filtersList)
    setFiltersList([...filtersList])
  }

  const recUpdateDateConditionChild = (value, i, item) => {
    if (i.length == 1) {
      item[i[0]].conditionChild = value
      item[i[0]].value = ['number_of_days_ago','number_of_days_from_now'].includes(value) ? 0 : moment()
    }
    else recUpdateDateConditionChild(value, i.slice(1), item[i[0]].items)
  }

  const updateNumberCondition = (value, i) => {
    recUpdateNumberCondition(value, i, filtersList)
    setFiltersList([...filtersList])
  }

  const recUpdateNumberCondition = (value, i, item) => {
    if (i.length == 1) {
      switch (value) {
        case 'is not empty':
          item[i[0]] = {...item[i[0]], condition: '>', conditionChild: value, value:  0}
          break
        case 'is empty':
          item[i[0]] = {...item[i[0]], condition: '=', conditionChild: value, value:  0}
          break
        default:
          item[i[0]] = {...item[i[0]], condition: value, conditionChild: value}
      }
    }
    else recUpdateNumberCondition(value, i.slice(1), item[i[0]].items)
  }

  const onFiltersSubmit = () => { onSubmit(filtersList) }

  const onDeleteFilter = (i) => {
    recOnDeleteFilter(i, filtersList)
    setFiltersList([...filtersList])
  }

  const recOnDeleteFilter = (i, item) => {
    if (i.length == 1) item.splice(i[0],1)
    else recOnDeleteFilter(i.slice(1), item[i[0]].items)
  }

  return <Modal container={document.body} show={true} onHide={onClose} className='filters-modal'>
    <Modal.Header closeButton>
      <Modal.Title>Filters</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className='filters-list'>
        <table className='table text-center zero-padding-x'>
          <tbody>
          {filtersList.length > 0 && filtersList.map((filter, index) => filter.group ?
            <GroupFilter
              key={index}
              filter={filter}
              indexTop={[index]}
              allColumns={allColumns}
              updateColumn={updateColumn}
              regionsAndLocations={regionsAndLocations}
              updateType={updateType}
              updateCondition={updateCondition}
              updateValue={updateValue}
              updateDateConditionChild={updateDateConditionChild}
              updateNumberCondition={updateNumberCondition}
              onDeleteFilter={onDeleteFilter}
              addCondition={addCondition}
              addConditionGroup={addConditionGroup}
            /> :
            <SimpleFilter
              key={index}
              filter={filter}
              i={[index]}
              allColumns={allColumns}
              updateColumn={updateColumn}
              regionsAndLocations={regionsAndLocations}
              updateType={updateType}
              updateCondition={updateCondition}
              updateValue={updateValue}
              updateDateConditionChild={updateDateConditionChild}
              updateNumberCondition={updateNumberCondition}
              onDeleteFilter={onDeleteFilter}
            />)
          }
          </tbody>
        </table>
      </div>
      <br/>
      <div className='form-group'>
        <div className='col-sm-3 text-right'>
          <a onClick={()=> addCondition([-1])} className='btn'>&#43; Add condition</a>
        </div>
        <div className='col-sm-5 text-left'>
          <a onClick={()=> addConditionGroup([-1])} className='btn'>&#43; Add condtition group</a>
        </div>
        <div className='col-sm-2 text-right'>
          <a onClick={onClose} className='btn btn-default'>Cancel</a>
        </div>
        <div className='col-sm-2 text-left'>
          <a onClick={onFiltersSubmit} className='btn btn btn-primary'>Apply</a>
        </div>
      </div>
    </Modal.Body>
  </Modal>
}

export default FilterForm
